import { useMutation } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { SupportRequestApi, ISupportRequestPayload } from '../../../apis/SupportRequestApi/SupportRequestApi';
import { AppMedError } from '../../../error/AppMedError';

export function useSubmitSupportRequest() {
    const { t } = useTranslation();

    return useMutation<void, AppMedError, ISupportRequestPayload>({
        mutationKey: ['supportRequest', 'submit'],
        mutationFn: async (data: ISupportRequestPayload) => {
            return await SupportRequestApi.submit(data);
        },
        onSuccess: () => {
            notifications.show({
                title: t('supportRequest.success'),
                message: t('supportRequest.successMessage'),
                color: 'green',
            });
        },
        onError: (error: AppMedError) => {
            notifications.show({
                title: t('supportRequest.error'),
                message: error?.message || t('supportRequest.errorMessage'),
                color: 'red',
            });
        },
    });
}
